import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'title-picking',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss']
})
export class TitlePickingComponent implements OnInit {

  constructor() {}

  ngOnInit() {}

}
